"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./index");
const text_1 = require("./text");
class Heading extends index_1.TopLevelNode {
    constructor(level) {
        super();
        this.level = level;
        this.content = new index_1.ContentNode('heading');
        if (level < 1 || level > 6) {
            throw new Error('Level must be in the range of 1-6');
        }
    }
    link(text, href, title) {
        this.content.add(text_1.link(text, href, title));
        return this;
    }
    text(text) {
        this.content.add(text_1.plain(text));
        return this;
    }
    toJSON() {
        return Object.assign({}, this.content.toJSON(), { attrs: {
                level: this.level
            } });
    }
}
exports.Heading = Heading;
//# sourceMappingURL=heading.js.map